// i18n.config.ts

export default defineI18nConfig(() => ({
  // We'll fill this in momentarily
  numberFormats,
}))
